import SimpleIntegration from './SimpleIntegration'

export default SimpleIntegration
